import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"

import { useDeleteProjectChildren } from "entities/project-children/api/useDeleteProjectChildren"

import { DeleteProjectChildrenOverlayProps } from "../DeleteProjectChildrenOverlay"
import { DeleteProjectChildrenOverlayViewModel } from "../DeleteProjectChildrenOverlayView"

export const useDeleteProjectChildrenOverlayModel = ({
  payload
}: DeleteProjectChildrenOverlayProps): DeleteProjectChildrenOverlayViewModel => {
  const { closeOverlay } = useCurrentOverlay()
  const deleteProjectChildren = useDeleteProjectChildren()

  const handleDelete = useEvent(() => {
    deleteProjectChildren({
      projectID: payload.projectID,
      childrenToDelete: payload.childrenToDelete
    })
    closeOverlay()
  })

  return {
    onDelete: handleDelete,
    onCancel: closeOverlay
  }
}
